import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem('token');


export const fetchAcademyData = async () => {
  try {
    const response = await axios.get(`${BACKEND}/academy`,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      console.log("response.data",response.data)
    return response.data;
  } catch (error) {
    throw new Error('Error fetching academy data');
  }
};
export const verifyAcademy = async (academyId, newStatus) => {
  try {
    console.log(`Updating academy verification status: ${academyId} -> ${newStatus}`);
    const response = await axios.put(`${BACKEND}/academy/verify/${academyId}`, { verify: newStatus });
    return response.data;
  } catch (error) {
    console.error('Error updating verification status:', error.response ? error.response.data : error);
    throw error;
  }
};

export const signup = async (formData) => {
  try {
    const response = await axios.post(`${BACKEND}/auth/addacademyfromadmin`, formData);
    return response.data.populatedAcademy;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const deleteAcademy = async (academyId, token) => {
  try {
    const response = await axios.delete(`${BACKEND}/academy/${academyId}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Pass token for authentication
      },
    });

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const updateAcademy = async (formData) => {
  console.log("formData",formData)
  try {
    const response = await axios.put(`${BACKEND}/editAcademyFromAdmin`, formData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};


